import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import PropTypes from 'prop-types'
import { useisLoading } from '../../hook/useisLoading';
import ErrorMessage from '../../components/common/ErrorMessage';
import { Alert, Button, Card, Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../../components/common/PageTitle';
import { Link } from 'react-router-dom';
import types from '../../types/types';
import { useSelector } from 'react-redux';
import Loading from '../../components/common/Loading';
import { set } from 'react-global-configuration';
import { AccountsAPI, AccountUserAPI } from '../../components/apis';
import helperDataTable from '../../components/helpers/helperDataTable';
import { confirmAlert } from 'react-confirm-alert';
import { ButtonDelete } from '../../components/common/ButtonDelete';
import { ButtonView } from '../../components/common/ButtonView';
import { ButtonEdit } from '../../components/common/ButtonEdit';
import { NoData } from '../../components/common/NoData';
import { ButtonHelp } from '../../components/common/ButtonHelp';
import { ButtonAddEntity } from '../../components/common/ButtonAddEntity';

export const Accounts = (props, context) => {
    
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);

    const [apiAccounts, setApiAccounts] = useState(null);

    const [accounts, setAccounts] = useState([]);
    const [backendError, setBackendError] = useState(null);

    const { user, token } = useSelector(state => state.user);
    
    // Load accounts
    useEffect(() => {
        
        if (token) {
            setApiAccounts(new AccountsAPI(token, props.idAccount));
        }

    }, [token])


    useEffect(() => {

        if (apiAccounts) {
            _getAccounts();
        }

    }, [apiAccounts])
    

    const _getAccounts =  () => {
        
        if(user != null && user.roles[0].id === types.USER_ROOT_ID){
            apiAccounts.getAll().then(accounts => {
                hideSpinner();
                setAccounts(accounts);
                if (accounts.length > 0){
                    setTimeout(helperDataTable("#accountsTable", 5, context), 200);
                }
            }).catch(err => {
                hideSpinner();
                setBackendError(err);
            });
        }    
    }    

    const removeAccount = (event, id, name) => {
        event.preventDefault();
        event.stopPropagation();

        confirmAlert({
            title: '',
            message: context.t('Are you sure you want to delete the account') + ": " + name,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        showSpinner();
                        var accountsTable = $('#accountsTable').DataTable();
                        accountsTable.clear();
                        accountsTable.destroy();

                        apiAccounts.delete(id).then(() => {
                            console.log("Account '" + name +"' has been removed.");
                            // _getAccounts();
                        }).catch(err => {
                            hideSpinner();
                            setBackendError(err);
                        });
                        hideSpinner();
                    }
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        })
    }

    // Handle and remove backend erros in UI
    const dismiss = () => {
        setBackendError(null);
    }
    
    if (isLoading) {
        return <Loading/>
    } else {
        return (
            <div>
                <ErrorMessage message={ backendError }/>

                <Container  fluid className="main-content-container px-4">
                    <Row noGutters className="page-header py-4">
                        <PageTitle title={context.t('Accounts')} subtitle={context.t('List')} className="text-sm-left mb-3" />
                        {user.roles[0].id === types.USER_ROOT_ID ? (
                            <ButtonAddEntity id="UG_accountAddEntity" to={'/accounts/new'} icon="verified_user"/>
                        ) : (
                            ''
                        )}
                        <ButtonHelp page={"Accounts"} context={context}/>
                    </Row>
                    <br/>
                        { accounts && accounts.length > 0 ?
                        (
                            <table id="accountsTable" className="snx-table-list">
                                {/* <thead><tr><th></th></tr></thead> */}
                                <tbody>
                                    {accounts && accounts.map(account => {                                
                                        return (
                                            <tr key={account.id} style={{ margin: '10px' }}>
                                                <td>
                                                    <Card className="snx-card-list">  
                                                        <Card.Header className='snx-card-list-header'>
                                                            <Row>
                                                                <Col id="UG_accountName">
                                                                    <i className="material-icons snx-icon md-18">verified_user</i>
                                                                    <span> {account.name} </span>
                                                                </Col>
                                                                    {(user.roles[0].id === types.USER_ROOT_ID)? (
                                                                        <>
                                                                            <Col className="pull-right"> 
                                                                                <ButtonDelete id="UG_accountDelete" onClick={e => { removeAccount(e, account.id, account.name) }} buttonClass="float-right" />
                                                                                <ButtonEdit id="UG_accountEdit" to={'/accounts/edit/'+account.id} buttonClass="float-right" />
                                                                                <ButtonView id="UG_accountView" to={'/home/'+account.id} buttonClass="float-right" />
                                                                            </Col>
                                                                        </>
                                                                    ) : ('')}
                                                            </Row>
                                                        </Card.Header>
                                                        <Card.Body className='snx-card-list-body'>
                                                            <Row id="UG_accountDetails">
                                                                <Col>
                                                                    <i className="material-icons snx-icon">featured_play_list</i> {account.business_id}
                                                                    <br/>
                                                                    <i className="material-icons snx-icon">location_on</i> {account.address}
                                                                    <br/>
                                                                    <i className="material-icons snx-icon">email</i> {account.email}
                                                                    <br/>
                                                                    <i className="material-icons snx-icon">local_phone</i> {account.phone_number}
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col className="snx-date">
                                                                    <small className="pull-right"> <i className="material-icons">access_time</i> {account.created_at}</small>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </td>
                                            </tr>
                                        )})
                                    }
                                </tbody>
                            </table>
                        ): (
                            <NoData/>    
                        )}
                </Container>
                <br/>
                <br/>
            </div>
        )
    }
}


Accounts.contextTypes = {
    t: PropTypes.func
}

export default Accounts;
  